import { render, staticRenderFns } from "./datastatic.vue?vue&type=template&id=33ab9b85&scoped=true&"
import script from "./datastatic.vue?vue&type=script&lang=js&"
export * from "./datastatic.vue?vue&type=script&lang=js&"
import style0 from "./datastatic.vue?vue&type=style&index=0&id=33ab9b85&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ab9b85",
  null
  
)

export default component.exports